import { AccordionSummary } from "@mui/material";
import { styled } from "@mui/system";

const AccordionSummarys = styled(AccordionSummary)(({ theme }) => ({
  padding: 0,
  fontSize: theme.typography.h6.fontSize,
  fontWeight: theme.typography.h6.fontWeight,
  lineHeight: theme.typography.h6.lineHeight,
  fontFamily: theme.typography.h6.fontFamily,
  color: "#101828",
}));
export default AccordionSummarys;
